
<template>
  <div class="top_bar">
    <el-menu
      :active-text-color="variables.menuActiveText"
      :default-active="activeMenu"
      mode="horizontal"
      @select="handleSelect"
    >
      <!-- <el-scrollbar tag="div" :native="false" ref="elscrollbar">
        <div v-for="(item, index) in routes" :key="index" class="nav-item">
          <app-link :to="resolvePath(item)">
            <el-menu-item v-if="!item.hidden" :index="item.path">{{
              item.meta ? item.meta.title : item.children[0].meta.title
            }}</el-menu-item>
          </app-link>
        </div>
      </el-scrollbar> -->
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLink from "./Sidebar/Link";
import { constantRoutes } from "@/router";
import variables from "@/styles/variables.scss";
import { isExternal } from "@/utils/validate";
import { resetRouter } from "@/router/index";
export default {
  name: "Topbar",
  components: {
    AppLink,
  },
  data() {
    return {
      routes: [],
    };
  },
  
  created(){
    this.routes=constantRoutes
    // this.routes=JSON.parse(localStorage.getItem("newRouter"))
    
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      this.initCurrentRoutes();
      // console.log(meta);
      // if set path, the sidebar will highlight the path you set
      // console.log(meta.activeMenu)
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // 如果是首页,首页高亮
      if (path === "/dashboard") {
        return "/";
      }
      // 如果不是首页,高亮一级菜单
      const activeMenu = "/" + path.split("/")[1];
      return activeMenu;
    },
    variables() {
      return variables;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    ...mapGetters(["avatar"]),
  },
  mounted() {
    this.initCurrentRoutes();
    // 监听el-scrollbar 的里面的 真正的滚动层
    // .el-scrollbar__wrap 是被嵌套在.el-scrollbar 中的
    // document
    //   .querySelector(".top_bar .el-scrollbar__wrap")
    //   .addEventListener("mousewheel", function (e) {
    //     e.preventDefault();
    //     this.scrollLeft += e.wheelDelta > 0 ? -100 : 100;
    //   });
  },
  methods: {
    // 通过当前路径找到二级菜单对应项,存到store,用来渲染左侧菜单
    initCurrentRoutes() {
      const { path } = this.$route;
      let route = this.routes.find(
        (item) => item.path === "/" + path.split("/")[1]
      );
      // 如果找不到这个路由,说明是首页
      if (!route) {
        route = this.routes.find((item) => item.path === "/");
      }
      this.$store.commit("permission/SET_CURRENT_ROUTES", route);
      this.setSidebarHide(route);
    },
    // 判断该路由是否只有一个子项或者没有子项,如果是,则在一级菜单添加跳转路由
    isOnlyOneChild(item) {
      if (item.children && item.children.length === 1) {
        return true;
      }
      return false;
    },
    resolvePath(item) {
      // 如果是个完成的url直接返回
      // console.log(item)
      if (isExternal(item.path)) {
        return item.path;
      }
      // 如果是首页,就返回重定向路由
      if (item.path === "/") {
        // const path = item.redirect;
        const path = "/";
        return path;
      }

      // 如果有子项,默认跳转第一个子项路由
      let path = "";
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 如果path是个外部链接（不建议）,直接返回链接,存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
        if (isExternal(item.path)) {
          path = item.path;
          return;
        }
        // 第一次需要父项路由拼接,所以只是第一个传parent
        if (parent) {
          path += parent.path + "/" + item.path;
        } else {
          path += "/" + item.path;
        }
        // 如果还有子项,继续递归
        if (item.children) {
          getDefaultPath(item.children[0]);
        }
      };

      if (item.children) {
        getDefaultPath(item.children[0], item);
        return path;
      }
      return item.path;
    },
    handleSelect(key, keyPath) {
      // 把选中路由的子路由保存store
      console.log(key)
      console.log(keyPath)
      if(key!='/UrbanIntegration'){
        return
      }
      const route = this.routes.find((item) => item.path === key);
      this.$store.commit("permission/SET_CURRENT_ROUTES", route);
      this.setSidebarHide(route);
    },
    // 设置侧边栏的显示和隐藏
    setSidebarHide(route) {
      if (!route.children || route.children.length === 1) {
        this.$store.dispatch("app/toggleSideBarHide", true);
      } else {
        this.$store.dispatch("app/toggleSideBarHide", false);
      }
    },
  },
  // mounted() {
  //   // 默认模拟激活根目录 (临时解决)
  //   this.handleSelect("/", ["/"]);
  //   // 监听el-scrollbar 的里面的 真正的滚动层
  //   // .el-scrollbar__wrap 是被嵌套在.el-scrollbar 中的
  //   document
  //     .querySelector(".el-scrollbar__wrap")
  //     .addEventListener("mousewheel", function (e) {
  //       e.preventDefault();
  //       this.scrollLeft += e.wheelDelta > 0 ? -100 : 100;
  //     });
  // },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.top_bar {
  display: flex !important;
  margin: 0 15px;
  border-radius: 5px;
  margin-top: $topBarHeight;
  overflow: hidden;
  .el-menu {
    flex: 1;
    overflow: hidden;
    .el-scrollbar {
      width: 100%;
      white-space: nowrap;
    }
  }
  .el-menu {
    float: left;
    border: none !important;
    background-color: $topBarBg;
     div:nth-child(5){
       .el-menu-item{
          background-color: $topBarFocus !important;
        color: $menuText !important;
        // transform: scale(1.2);
        font-size: 16px;
       }

     }
    .nav-item {
      display: inline-block;
      .el-menu-item {
        // font-size: 18px;
        // color: #49496a;
        color: $menuText !important;
        &:hover {
          background-color: transparent;
          font-size: 16px;
          color: $menuText !important;
        }
        // &:focus {
        //   background-color: $topBarFocus !important;
        //   color: $menuText !important;
        //   transform: scale(1.2);
        // }
      }
      .is-active {
        // background-color: $topBarFocus !important;
          background-color: $topBarBg !important;
        color: $menuText !important;
        // transform: scale(1.2);
        font-size: 16px;
      }
    }
  }
}
</style>

